(function ($) {
    'use strict';
    var os_name = AwesomeUtil.detect_os(); // detect user OS

    // if MAC => addClass to fix hidden scroll
    // MUST ADDS before page load to prevent flickering content
    if (os_name == 'MacOS') $('html').addClass('mac');

    $(function () {
        var panel,
            a_ajax = new AwesomeAjax('aetfree'),
            aet_ajax = new AET_Ajax();

        self.spinner = $('#main-spinner');
        self.content = $('#a-excited-testimonials-free')


        // Show spinner animation
        self.animation_start = function () {
            // show spinner animation
            self.spinner.addClass('fade-animation-in');
        };

        // Hide spinner animation
        self.animation_end = function () {
            self.spinner.removeClass('fade-animation-in'); // hide spinner animation
        };

        // Hide panel content
        self.hide_content = function () {
            self.content.removeClass('fade-animation-in');
        };

        // Show panel content
        self.show_content = function () {
            self.content.addClass('fade-animation-in');
        };

        // Prevent form submit on Enter hitting
        $('[data-action="add-model"]').on('keypress', function (e) {
            return e.keyCode != 13;
        });

        // Add new Testimonial or Group from field
        $('input[data-action="add-model"]').on('keyup', function (e) {
            var $self = $(this);
            var $spinner = $(this).parents('.panel-footer').find('.a-spinner');
            var $form = $(this).parent('form');
            var model = $(this).attr('data-model');
            // if Enter keyup
            if (e.keyCode == 13) {
                $spinner.show();
                a_ajax.ajax({
                    action: 'aetfree_update_or_new_' + model,
                    data: {
                        data: {
                            'name': $form.find('input').val()
                        },
                        'model': model
                    },
                    success_handler: function (data) {
                        $self.val('');
                        setTimeout(function () {
                            window.location.reload();
                        }, 500);
                    }
                });
            }
        });

        $('[data-action="modal"]').lightbox({
            minWidth: 50,
            minHeight: 100,
            labels: {
                close: '<svg viewBox="0 0 56 56"><use xlink:href="#icon-delete"></use></svg>'
            }
        });

        // Init tooltips
        var args = {
            id: 'aet',
            container: '#action-add-buttons',
            content: '#action-add-buttons-tooltip',
            width: 180,
            data: {}
        };
        var aet_tooltip = new AwesomeTooltip(args);
        aet_tooltip.init();
        aet_ajax.get_templates();
    });
})(jQuery);